import React from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import CheckIcon from "@material-ui/icons/Check";
import {CheckCircle, CloudDownloadOutlined} from "@material-ui/icons";
import {green, grey, red} from "@material-ui/core/colors";
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
    titleContainer: {
        display: 'flex'
    },
    title: {
        marginLeft: theme.spacing(1)
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}))

function PickupSaveNotification(props) {
    const {
        showPickupSaveNotification,
        closePickupSaveNotification,
        message,
        success,
        url
    } = props;

    const handleClose = () => {
        closePickupSaveNotification();
    }

    const handleDownloadReportClick = (e) => {
        e.preventDefault();
        handleClose();
        const newWindow = window.open(url);
        if (newWindow) newWindow.opener = null;
    }

    const classes = useStyles();
    return (
        <Dialog open={showPickupSaveNotification}
                maxWidth='sm'
                fullWidth={true}
        >
            <DialogTitle disableTypography>
                <div className={classes.titleContainer}>

                    <Typography variant='h6' style={{color: success ? grey[500] : red[500]}} className={classes.title}
                                display='inline'>
                        Pickup status
                    < /Typography>
                </div>

            </DialogTitle>
            <DialogContent dividers>
                <Typography>{success}</Typography>
                <div style={{display: "flex"}}>
                    {success ? <CheckCircle style={{color: green[500]}}/> :
                        <CancelIcon style={{color: red[500]}}/>}
                    <Typography color='textSecondary' className={classes.title} display='inline'>{message}</Typography>

                </div>
            </DialogContent>
            <DialogActions>
                {success && url ?
                    <Controls.Button
                        variant='text'
                        text='Download report'
                        onClick={handleDownloadReportClick}
                        startIcon={<CloudDownloadOutlined>Download</CloudDownloadOutlined>}/> : null}
                <Controls.Button
                    startIcon={<CheckIcon/>}
                    onClick={handleClose}
                    text="Done"
                />
            </DialogActions>
        </Dialog>
    );
}

export default PickupSaveNotification;
